import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Home } from "./Home";
import { Dashboard } from "./Dashboard";
import { AdminPage } from './AdminPage';
import { RegisterForm } from "./RegisterForm";
import { ToastContainer } from "react-toastify";
import { AudioButton } from "./AudioButton";
import { useAudio } from "./Stores/useAudio";
import { useEffect, useState } from "react";
import { PlayGif } from "./PlayGifs";
import { usePlayGif } from "./Stores/useGif";

export const Components = () => {

  
  const { setAudioStatus } = useAudio();
  const { showGif } = usePlayGif();
  const [clicked, setClicked] = useState(false);

  useEffect(() => {
    const handleClick = () => {
      if (!clicked) {
        setClicked(true);
        setAudioStatus(false);
        document.removeEventListener("click", handleClick); // Remove listener after first click
      }
    };

    const handleVisibilityChange = () => {
      if (document.hidden) {
        setAudioStatus(true);
      } else {
        setAudioStatus(false);
      }
    };

    function handleClickOutside(event) {
      if (!document.contains(event.target)) {
        setAudioStatus(true);
      }
    }

    document.addEventListener("visibilitychange", handleVisibilityChange);
    document.addEventListener("click", handleClick);
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      document.removeEventListener("click", handleClick);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [clicked, setAudioStatus]);
  return (
    <Router>  {/* Added Router wrapper */}
    <div className="relative overflow-hidden">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/adminPage" element={<AdminPage />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/signup" element={<RegisterForm />} />
      </Routes>
      <ToastContainer />
      <AudioButton />
      {showGif && <PlayGif />}
    </div>
  </Router>
  )
}
